/**
 * Load more products via Shopify Section Rendering API.
 * Fetches the next page of the collection section (with inline banners) and appends grid items.
 * @see https://shopify.dev/docs/api/ajax/section-rendering
 */
(function () {
  const wrapper = document.querySelector('[data-load-more-wrapper]');
  const btn = document.querySelector('[data-load-more-btn]');
  const grid = document.getElementById('product-grid');
  const sectionContainer = document.querySelector('.collection-section--load-more');

  if (!wrapper || !btn || !grid || !sectionContainer) return;

  let sectionId = sectionContainer.getAttribute('data-section-id');
  if (!sectionId) {
    const sectionWrapper = sectionContainer.closest('[id^="shopify-section-"]');
    sectionId = sectionWrapper ? sectionWrapper.id.replace(/^shopify-section-/, '') : null;
  }
  if (!sectionId) return;

  btn.addEventListener('click', async function () {
    const nextPage = btn.getAttribute('data-next-page');
    const totalPages = parseInt(btn.getAttribute('data-pagination-pages') || '1', 10);
    if (!nextPage || parseInt(nextPage, 10) > totalPages) return;

    btn.disabled = true;
    btn.classList.add('loading');

    const baseUrl = `${window.location.pathname}${window.location.search ? window.location.search + '&' : '?'}`;
    const sectionsUrl = `${baseUrl}page=${encodeURIComponent(nextPage)}&sections=${encodeURIComponent(sectionId)}`;
    const sectionIdUrl = `${baseUrl}page=${encodeURIComponent(nextPage)}&section_id=${encodeURIComponent(sectionId)}`;

    try {
      let sectionHtml = null;
      try {
        const response = await fetch(sectionsUrl, { headers: { Accept: 'application/json' } });
        if (response.ok) {
          const data = await response.json();
          sectionHtml = data[sectionId];
          if (sectionHtml == null) {
            const keys = Object.keys(data || {});
            const fallback = keys.find(function (key) {
              const val = data[key];
              return typeof val === 'string' && val.indexOf('product-grid') !== -1;
            });
            sectionHtml = fallback ? data[fallback] : null;
          }
        }
      } catch (_) {}

      if (sectionHtml == null) {
        const htmlResponse = await fetch(sectionIdUrl, { headers: { Accept: 'text/html' } });
        if (!htmlResponse.ok) throw new Error('Section request failed: ' + htmlResponse.status);
        sectionHtml = await htmlResponse.text();
      }

      if (sectionHtml == null || typeof sectionHtml !== 'string') {
        throw new Error('Section not in response');
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const fetchedGrid = doc.getElementById('product-grid');
      const meta = doc.querySelector('.collection-load-more-meta');
      const nextBtn = doc.querySelector('[data-load-more-btn]');

      if (fetchedGrid) {
        grid.insertAdjacentHTML('beforeend', fetchedGrid.innerHTML);
      }

      const newNextPage = meta ? meta.getAttribute('data-next-page') : (nextBtn ? nextBtn.getAttribute('data-next-page') : null);
      btn.setAttribute('data-next-page', newNextPage || '');

      if (!newNextPage) {
        wrapper.classList.add('load-more--done');
        wrapper.hidden = true;
      }
    } catch (err) {
      btn.disabled = false;
      btn.classList.remove('loading');
      console.error('Load more failed:', err);
    } finally {
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  });
})();
